<template>
    <div class="dragAreaContainer">
        <div class="dragArea" ref="dragArea" @dragover.prevent="dragover" @dragleave.prevent="dragleave" @drop.prevent="drop">
            <div class="dragAreaContent">
                <div class="dragMessage">
                    <img class = "uploadImage" src = "/img/upload-cloud.svg">
                    <p class = "dragText">
                        Select a file or drag and drop here
                    </p>
                    <p v-if = "!hideText" class = "imageText">
                        JPG, PNG or PDF, file size no more than 6MB
                    </p>
                    <p v-if = "!hideText" class = "imageText">
                        Please upload both front & back images
                    </p>
                </div>
                <label for="file-upload" class="fileUploadButton" v-if = "hideMultipleFile">
                    <input
                        type="file"
                        name="file-upload"
                        id="file-upload"
                        class="inputField"
                        @change="onChange"
                        ref="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                    />
                    Browse Files
                </label>
                <label for="file-upload" class="fileUploadButton" v-if = "!hideMultipleFile">
                    <input
                        type="file"
                        multiple
                        name="file-upload"
                        id="file-upload"
                        class="inputField"
                        @change="onChange"
                        ref="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                    />
                    Browse Files
                </label>
            </div>
            <ul class="mt-4" v-if="this.fileList.length && !hideMultipleFile" v-cloak>
                <li class="text-sm p-1" v-for="(file, index) in fileList" :key="index">
                    {{ file.name }}
                    <v-icon @click="remove(fileList.indexOf(file))" title="Remove file">
                        fas fa-times-circle
                    </v-icon>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        hideText: {
            default: false,
            type: Boolean
        },
        hideMultipleFile: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            fileList: []
        }
    },
    methods: {
        onChange () {
            this.fileList = [...this.$refs.file.files]
            this.$emit('filesSelected', this.fileList)
        },
        emitFileSelection () {
            this.$emit('filesSelected', this.fileList)
        },
        remove (i) {
            this.fileList.splice(i, 1)
            this.$emit('removeFile', i)
        },
        dragover (event) {
            event.preventDefault()
        },
        drop (event) {
            const files = event.dataTransfer.files;
            [...files].forEach(file => {
                this.fileList.push(file)
            })
            this.emitFileSelection()
        }
    }
}
</script>

<style lang="scss" scoped>
.dragAreaContainer {
    display: flex;
    align-items: center;
    justify-content: center;
}
.dragArea {
    width: 500px;
    border-width: 1px;
    border: 1px solid #E0E0E0;
    border-radius: 12px;
    padding: 3rem;

    .dragAreaContent {
        display: flex;
        flex-direction: column;
        align-items: center;

        .fileUploadButton {
            color: #002FA7;
            font-weight: 600px;
            font-size: 13px;
            padding-top: 5px;
            text-decoration: underline;
            cursor: pointer;
        }
    }

    .dragMessage {
        display: flex;
        flex-direction: column;

        .v-icon.v-icon {
            font-size: 48px;
        }
    }

    ul {
        list-style-type: none;

        li {
            display: flex;
            justify-content: space-between;
            padding: 4px;
        }
    }
}

.inputField {
    width: 1px;
    position: absolute;
    overflow: hidden;
    opacity: 0;
    height: 1px;
}

.bg-green-300 {
    background: #f1e9c6;
}

.bg-gray-100 {
    background: #E5E5E5;
}
.uploadImage {
    padding-bottom: 10px;
    height: 60px;
}
.dragText {
    text-align: center;
    color: #232323;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 12px !important;
}
.imageText {
    color: #9e9e9e;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 12px !important;
}
</style>
